<cdk-virtual-scroll-viewport itemSize="200" class="example-viewport cdk">
  <ng-container *ngIf="viewCarousel; else nonCarousel">
    <app-carousel>
      <ng-template carouselItem="1">
          <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
      </ng-template>

      <ng-template carouselItem="2">
        <div>
          <h2 style="display: flex; justify-content: center;">
            <strong>Recursos</strong>
          </h2>
          <data-table [title]="''" [columns]="columnsResouces" [configuration]="configurationResouces"
            [url]="urlGetTablaResourcesActivity" [params]="paramsResources" (internalData)="dataResources($event)">
          </data-table>
        </div>
      </ng-template>
    </app-carousel>
  </ng-container>

  <ng-template #nonCarousel>
    <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
  </ng-template>
</cdk-virtual-scroll-viewport>

<ng-template #descriptionTemplate>
  <div class="content-container" *ngIf="bodyActividades">
    <div class="header">
      <div class="header-info">
        <h1><strong>Código: {{bodyActividades.code}}</strong></h1>
        <h2 *ngIf="bodyActividades.componentName != null">
          <strong>Componente: {{bodyActividades.componentName}}</strong>
        </h2>
      </div>
    </div>

    <div class="info-list">
      <mat-list>
        <mat-list-item>
          <strong>Creada por:</strong>&nbsp;{{bodyActividades.creatorUser}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <strong>Odómetro/Horómetro actual: </strong>&nbsp;{{bodyActividades.currentOdometer | number:'1.0-0'}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <strong>Frecuencia (días): </strong>&nbsp;{{bodyActividades.timeFrequency}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <strong>Frecuencia (odómetro/horómetro): </strong>&nbsp;{{bodyActividades.odometerFrequency | number:'1.0-0'}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item *ngIf="!inventoryModule">
          <strong>Recursos: </strong>&nbsp;{{bodyActividades.resources}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <strong>Fecha próximo mantenimiento: </strong>&nbsp;{{bodyActividades.lastMttoDate}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <strong>Odómetro/Horómetro último mantenimiento: </strong>&nbsp;{{bodyActividades.odometerLastMtto | number:'1.0-0'}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
          <strong>Costo mantenimiento: </strong>&nbsp;{{bodyActividades.cost | number:'1.0-0'}}
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="description-item">
          <strong>Descripción: </strong>&nbsp;
          <span class="description-text">{{bodyActividades.description}}</span>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    </div>

    <ng-container *ngIf="!viewCarousel">
      <div class="button-container">
        <button class="button-save mat-elevation-z5" color="primary" (click)="OT()" mat-raised-button>
          Crear orden de trabajo
        </button>
      </div>
    </ng-container>
  </div>
</ng-template>